import { Routes, Route, Navigate } from 'react-router-dom';
import React from 'react';
import LoginScreen from '../pages/auth/LoginScreen';

export default function GuestRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginScreen />} />
      <Route path="*" element={<Navigate to="/login" />} />
    </Routes>
  );
}
